// Rafal Template

import "../sass/rafal.scss";
import "./jquery.min.js"; // Only used on the homepage

console.log("This is the rafal!");
